import { notifications } from '@mantine/notifications';
import { failureKindOf, failureMessage } from './api';

function styles(background: string) {
  return {
    root: { backgroundColor: background, color: 'var(--color-ink)' },
    description: { color: 'var(--color-ink)' },
  };
}

export function toastSaved(message: string): void {
  notifications.show({
    color: 'green',
    message,
    closeButtonProps: { 'aria-label': 'Dismiss notification' },
    styles: styles('var(--color-toast-success)'),
  });
}

export function toastFailed(message: string): void {
  notifications.show({
    color: 'red',
    message,
    closeButtonProps: { 'aria-label': 'Dismiss notification' },
    styles: styles('var(--color-toast-error)'),
  });
}

export function toastApiFailure(error: unknown, fallback: string): void {
  if (failureKindOf(error) === 'unauthorized') return;
  toastFailed(failureMessage(error, fallback));
}
